// import { Outlet } from 'react-router-dom'
// import Navigation from '../components/usables/Navigation'

export default function Button({text, danger, disabled, ...rootDOMAttributes}) {
  // const classes = (danger ? 'bg-danger-500 hover:bg-danger-900' : 'bg-violet-500 hover:bg-violet-700 text-white') + ' hover:text-white px-3 py-2 rounded-full'
  const classes = (danger ? 'bg-danger-500 hover:bg-danger-900' : 'bg-violet-500 hover:bg-violet-700 text-white') + ' inline-block px-6 py-2.5 text-white font-medium text-xs leading-tight rounded-full shadow-md focus:outline-none focus:ring-0 transition duration-150 ease-in-out' + (disabled ? ' pointer-events-none opacity-60' : '')
  return (
    <button {...rootDOMAttributes} className={classes}>
      {text}
    </button>
  )
}